/**
 * * Return sanitized locale with dash between language, country and variation
 */
export var getSanitizedLocaleForIntl = function getSanitizedLocaleForIntl(haLocale) {
  if (haLocale === 'no-NO' || haLocale === 'no_NO') {
    haLocale = 'nb_NO';
  }

  if (typeof haLocale === 'string' && haLocale.length >= 5) {
    return haLocale.substring(0, 2) + "-" + haLocale.substring(3, 5);
  } // default to US locale if incorrect format is provided


  return 'en-US';
};
//# sourceMappingURL=localeUtils.js.map